[
  {
    "id": "chapter:1a",
    "q": "An Instructional Permit allows you to:",
    "answer": {
      "text": "Operate a motor vehicle when supervised by a licensed driver 21 or older",
      "section": 1,
      "topic": "Instructional Permit Class C or M",
      "page": 12
    },
    "otherChoices": ["Operate a motor vehicle without supervision", "Observe another driver operate a motor vehicle"],
    "generated": {
      "parent": "sample:3",
      "type": "alt-answers",
      "rationale": "Alt-answers variant of sample:3 sourced from the handbook itself (originally appeared in the §1 chapter quiz on p.15). Tightens the correct answer wording from \"supervised by another driver\" to the stricter rule the handbook teaches under Instructional Permit Class C or M / Driving Restrictions on p.12: \"May only drive with a licensed adult in the front seat\" and \"Licensed adult must be at least 21 years old and have at least one-year driving experience.\" Question prompt and other-choices preserved as the handbook printed them."
    },
    "batch": "review-20260428",
    "version": 3,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:1b",
    "q": "With a Class C Driver’s License you may:",
    "answer": {
      "text": "Operate vehicles with a gross vehicle weight rating of less than 26,001 pounds",
      "section": 1,
      "topic": "Kansas Driver Licenses",
      "page": 15
    },
    "otherChoices": [
      "Operate any motor vehicle, regardless of size or weight",
      "Operate vehicles with a gross vehicle weight rating of more than 26,001 pounds"
    ],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "discarded"
  },
  {
    "id": "chapter:1c",
    "q": "Your Driver’s License will:",
    "answer": {
      "text": "Expire on your birthday",
      "section": 1,
      "topic": "Kansas Driver Licenses",
      "page": 15
    },
    "otherChoices": ["Never expire", "Expire after five years of issuance"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "discarded"
  },
  {
    "id": "sample:3",
    "q": "An Instruction Permit allows you to:",
    "answer": {
      "text": "Operate a motor vehicle when supervised by another driver",
      "section": 1,
      "topic": "Instructional Permit Restrictions",
      "page": 12
    },
    "otherChoices": ["Operate a motor vehicle without supervision", "Observe another driver operate a motor vehicle"],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:3:derived:a",
    "q": "Under an Instructional Permit, who may sit in the front seat besides the permit holder?",
    "answer": {
      "text": "Only the supervising licensed adult",
      "section": 1,
      "topic": "Instructional Permit Restrictions",
      "page": 12
    },
    "otherChoices": [
      "The supervising adult plus one other passenger",
      "Any licensed driver in addition to the supervising adult"
    ],
    "generated": {
      "parent": "sample:3",
      "type": "paired",
      "rationale": "Paired counterpart of sample:3. The handbook teaches the Instructional Permit driving restrictions as a single bulleted cluster on page 12. Where sample:3 covers the supervision privilege itself, this variant covers the front-seat occupancy restriction taught in the same cluster: 'No person but the supervising adult in the front seat.' Distractors weaken the rule by allowing additional front-seat occupants the handbook explicitly excludes. The variant does not duplicate chapter:1a (which is an alt-answers variant of sample:3 that tightens the supervisor age) because it tests a separate restriction in the same passage."
    },
    "batch": "review-20260502b",
    "version": 1,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "authored:s1-restricted-license-driving-hours",
    "q": "Under a restricted license, a 16-year-old may drive:",
    "answer": {
      "text": "From 5 a.m. to 9 p.m.",
      "section": 1,
      "topic": "Driving Restrictions 16-Year-Old",
      "page": 13
    },
    "otherChoices": ["From 5 a.m. to midnight", "From 6 a.m. to 10 p.m."],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s1-restricted-license-passengers",
    "q": "Under a restricted license, how many minor passengers may a 16-year-old carry?",
    "answer": {
      "text": "Only one, non-sibling, minor passenger",
      "section": 1,
      "topic": "Driving Restrictions 16-Year-Old",
      "page": 13
    },
    "otherChoices": ["No non-sibling minor passengers at all", "Up to three minor passengers"],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s1-instructional-permit-minimum-age",
    "q": "The minimum age for an Instructional Permit (Class C or M) is:",
    "answer": {
      "text": "14",
      "section": 1,
      "topic": "Instructional Permit Class C or M",
      "page": 12
    },
    "otherChoices": ["15", "17"],
    "generated": null,
    "batch": "expansion-r1-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s1-new-resident-90-days",
    "q": "After moving to Kansas, you are required to have a Kansas Driver's License within:",
    "answer": {
      "text": "90 days",
      "section": 1,
      "topic": "About This Manual",
      "page": 11
    },
    "otherChoices": ["30 days", "1 year"],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 2,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s1-fifteen-school-driving",
    "q": "A 15-year-old driver with a Restricted License may drive to and from school:",
    "answer": {
      "text": "Directly, over the most direct route, for the purpose of attendance on days school is in session",
      "section": 1,
      "topic": "Restricted License, Driving Restrictions 15-Year-Old",
      "page": 13
    },
    "otherChoices": [
      "Including to and from authorized school activities",
      "Only when accompanied by a licensed adult in the front seat"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 2,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s1-fifth-alcohol-revocation",
    "q": "A fifth BAC test result of .08 or greater, or a fifth refusal to submit to chemical testing, will result in:",
    "answer": {
      "text": "A permanent license revocation",
      "section": 1,
      "topic": "Loss of Driving Privileges",
      "page": 15
    },
    "otherChoices": ["A mandatory 1-year suspension", "A 30-day suspension of your license and driving privileges"],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 2,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s1-fourth-test-failure-wait",
    "q": "After the fourth failure of either the written test or the driving test, you must wait:",
    "answer": {
      "text": "A minimum of six months from the most recent failed exam",
      "section": 1,
      "topic": "Unsuccessful Examinations",
      "page": 14
    },
    "otherChoices": ["Only until the next working day", "One year"],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 2,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s1-revocation-reckless-driving",
    "q": "Your driving privileges may be revoked if you are convicted of:",
    "answer": {
      "text": "Reckless driving",
      "section": 1,
      "topic": "Loss of Driving Privileges",
      "page": 15
    },
    "otherChoices": [
      "Failing to report a traffic accident",
      "Transporting an open container of liquor or cereal malt beverage"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s1-farm-permit-qualification",
    "q": "To qualify for a Farm Permit, an applicant must:",
    "answer": {
      "text": "Reside on a farm or be employed for compensation on a farm",
      "section": 1,
      "topic": "Farm Permit (K.S.A. 8-296)",
      "page": 11
    },
    "otherChoices": ["Be at least 16 years of age", "Have held a state issued Learner's Permit for 1 year or more"],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s1-corrective-lens-restriction",
    "q": "If corrective lenses are required for you to meet the vision standard:",
    "answer": {
      "text": "A restriction will be placed on your license and you must wear corrective lenses anytime you are driving",
      "section": 1,
      "topic": "Required Noncommercial License Tests, Vision",
      "page": 13
    },
    "otherChoices": [
      "You will be denied a Driver's License",
      "You may drive without them for short trips, such as to a local corner store"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s1-out-of-state-license-age",
    "q": "Visitors, non-residents, and military members can drive in Kansas on a valid license from another state if they are at least:",
    "answer": {
      "text": "16 years old",
      "section": 1,
      "topic": "Out of State License or Driving on an Existing License",
      "page": 15
    },
    "otherChoices": ["15 years old", "18 years old"],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s1-expired-license-testing",
    "q": "If your driver license has been expired for more than 1 year:",
    "answer": {
      "text": "Full testing will be required, including the vision, written, and driving examinations",
      "section": 1,
      "topic": "Driver License Renewal",
      "page": 14
    },
    "otherChoices": ["Only a $1.00 penalty applies", "Only the written examination must be retaken"],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  }
]
